import React from 'react';

export default function AboutUs(){

    return(
        <>
        <h1>About Us</h1>
        <h5>We are a marketplace!</h5>
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatem nulla consequatur assumenda, 
            ratione enim asperiores veritatis, maiores mollitia tempora iusto, similique aperiam dicta repellendus.
             Doloribus consequuntur voluptates veniam commodi voluptatum.</p>
        </>
    )
}